import types from '../actionTypes';

export const deleteImageMapsRequest = id => ({
    type: types.DELETE_IMAGE_MAP_REQUEST,
    meta: { id },
});

export const deleteImageMapsRequestCompleted = id => ({
    type: types.DELETE_IMAGE_MAP_REQUEST_COMPLETED,
    meta: { id },
});
